export default __webpack_public_path__ + "static/media/english-to-danish-screenshot-01.2c992a76.png";